import { Middleware } from "redux";
import { SseStream } from "../utils/SseStream";
import { setMOTD } from "../features/MOTD/MOTDSlice";
import { setWaypoint } from "../features/Waypoint/WaypointSlice";
import { setActiveProject } from "../features/Project/ProjectSlice";
import { setActivePhase } from "../features/Phases/PhaseSlice";
import { setActiveEvents } from "../features/Actions/ActionSlice";
import { checkConnection } from "../features/Connection/ConnectionSlice";
import { setMeasurements } from "../features/Measurements/MeasurementSlice"
import { setGoBack } from "../features/GoBack/GoBackSlice";
import { addTableRow, addAcqTableRow } from "../features/Aggregate/AggregateSlice";

export const Streamware:Middleware = store => next => (action:any) =>{
    switch(action.type){
        
        case 'ssestream/connect':
            
            const ssestream = new SseStream()
            const stream_param = action.payload
            ssestream.connect(process.env.REACT_APP_API_URI+`/${stream_param}?type=stream`);
            
            ssestream.on('message', (data)=> {
                const resp = JSON.parse(data.data);
                if(stream_param == "settings/motd"){
                    store.dispatch(setMOTD(resp))
                }else if(stream_param == "settings/waypoint"){
                    store.dispatch(setWaypoint(resp))
                }else if(stream_param == "ping"){
                    store.dispatch(checkConnection(resp))
                }else if (stream_param == "projects/getActiveProject"){
                    store.dispatch(setActiveProject(resp))
                }else if(stream_param == "phases/getActivePhase"){
                    store.dispatch(setActivePhase(resp))
                }else if(stream_param == "events/getActiveEvents"){
                    store.dispatch(setActiveEvents(resp));
                }else if(stream_param == "measurements/getMeasurements"){
                    store.dispatch(setMeasurements(resp));
                }else if(stream_param == "goBack"){
                    store.dispatch(setGoBack(resp));
                }else if(stream_param == "projects/getAggregated"){
                    const messages = resp as { project:(number); table: "summary" | "acq"; row: (string | number)[] }[];
                    messages.forEach(r => {
                        if (r.table === "summary") {
                            store.dispatch(addTableRow({row:r.row, project:r.project}));
                        } else if (r.table === "acq") {
                            store.dispatch(addAcqTableRow({row:r.row, project:r.project}));
                        }
                    });
                }
            })
            break;
        case 'ssestream/disconnect':
            break;
        default:
            break;
    }
    return next(action);
}
